<template>
  <address class="user-address flex flex-col text-base not-italic px-6">
    <div class="flex items-center justify-between mb-2">
      <span class="mb-3 flex items-center gap-2 text-black">
        <FontAwesomeIcon :icon="faTruck" />

        Delivery Address
      </span>

      <AppButton
        v-if="showChange"
        class="border-0 p-0 w-fit text-secondary"
        @click="$emit('changeClicked')"
      >
        Change
      </AppButton>
    </div>

    <p class="m-0">
      <template v-if="userAddress.length > 0">
        <template
          v-for="(part, index) in userAddress"
          :key="part.id"
        >
          {{ part }}{{ index < userAddress.length - 1 ? ',' : '' }}

          <br v-if="index < userAddress.length - 1">
        </template>
      </template>

      <template v-else>
        N/A
      </template>
    </p>
  </address>
</template>

<script setup>
import { AppButton } from '@/components/app';
import { computed } from 'vue';
import { faList, faTruck } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

const props = defineProps({
  data: Object,
  showChange: Boolean,
});

defineEmits(['changeClicked']);

const userAddress = computed(() => {
  const line1 = [props.data.streetAddress, props.data.building].filter(Boolean).join(', ').trim();
  const line2 = [props.data.suburb, props.data.city].filter(Boolean).join(' ').trim();
  const line3 = [props.data.province, props.data.postalCode].filter(Boolean).join(' ').trim();

  return [
    line1,
    line2,
    line3,
  ].filter(Boolean);
});
</script>
